import { defineMessages } from 'react-intl';

export default defineMessages({
    modalTitle: {
        id: '_.TrueLayerModal.modalTitle',
        defaultMessage: 'Connect your business account'
    },
    title: {
        id: '_.TrueLayerModal.title',
        defaultMessage: 'How does it work?'
    },
    description: {
        id: '_.TrueLayerModal.description',
        defaultMessage: `Securely share your bank account’s data. Simply choose your bank below and then log in through your bank’s portal when prompted.`
    },
    bankEncryption: {
        id: '_.TrueLayerModal.bankEncryption',
        defaultMessage: 'Bank-grade encryption'
    },
    searchBarPlaceholder: {
        id: '_.TrueLayerModal.searchBarPlaceholder',
        defaultMessage: 'Search for your bank...'
    },
    bankListError: {
        id: '_.TrueLayerModal.bankListError',
        defaultMessage:
            'Unfortunately the bank you have chosen is not supported.'
    },
    bankListFooter: {
        id: '_.TrueLayerModal.bankListFooter',
        defaultMessage: `We're {footerLinkText} which allows us to offer Open Banking`
    },
    bankListFooterLink: {
        id: '_.TrueLayerModal.bankListFooterLink',
        defaultMessage: `https://www.fca.org.uk/about/what-we-do/the-fca`
    },
    bankListFooterLinkText: {
        id: '_.TrueLayerModal.bankListFooterLinkText',
        defaultMessage: `FCA registered`
    },
    bankConnectionTitle: {
        id: '_.TrueLayerModal.bankConnectionTitle',
        defaultMessage: 'What details am I sharing?'
    },
    bankConnectionDescription: {
        id: '_.TrueLayerModal.bankConnectionDescription',
        defaultMessage:
            'The following information will be shared with iwoca LTD:'
    },
    sharedInfoFullName: {
        id: '_.TrueLayerModal.sharedInfoFullName',
        defaultMessage: 'Full name'
    },
    sharedInfoAccountNumber: {
        id: '_.TrueLayerModal.sharedInfoAccountNumber',
        defaultMessage: 'Account number and sort code'
    },
    sharedInfoAccountBalance: {
        id: '_.TrueLayerModal.sharedInfoAccountBalance',
        defaultMessage: 'Account balance'
    },
    sharedInfoTransactionHistory: {
        id: '_.TrueLayerModal.sharedInfoTransactionHistory',
        defaultMessage: 'Transaction history, direct debits and standing orders'
    },
    bankEncryptionIntroText: {
        id: '_.TrueLayerModal.bankEncryptionIntroText',
        defaultMessage:
            'We use a partner called Truelayer, to access the information needed to assess your ability to repay a loan.'
    },
    bankEncryptionPermissionText: {
        id: '_.TrueLayerModal.bankEncryptionPermissionText',
        defaultMessage:
            'Truelayer needs your permission to access your information for 90 days.'
    },
    bankEncryptionRegulatedText: {
        id: '_.TrueLayerModal.bankEncryptionRegulatedText',
        defaultMessage:
            'Truelayer is FCA regulated, and won’t share or use your personal data for anything else.'
    },
    bankConnectionFooter: {
        id: '_.TrueLayerModal.bankConnectionFooter',
        defaultMessage: `By tapping ‘Allow’, you agree to {termsOfServiceLinkText} and {privacyPolicyLinkText}`
    },
    bankConnectionFooterTermsLinkText: {
        id: '_.TrueLayerModal.bankConnectionFooterTermsLinkText',
        defaultMessage: `Truelayer’s Terms of Service`
    },
    bankConnectionFooterTermsLink: {
        id: '_.TrueLayerModal.bankConnectionFooterTermsLink',
        defaultMessage: 'https://truelayer.com/legal/enduser_tos/'
    },
    bankConnectionFooterPrivacyLinkText: {
        id: '_.TrueLayerModal.bankConnectionFooterPrivacyLinkText',
        defaultMessage: 'Privacy Policy'
    },
    bankConnectionFooterPrivacyLink: {
        id: '_.TrueLayerModal.bankConnectionFooterPrivacyLink',
        defaultMessage: 'https://truelayer.com/legal/privacy/'
    },
    bankConnectionError: {
        id: '_.TrueLayerModal.bankConnectionError',
        defaultMessage:
            'Sorry, we ran into an issue while retrieving the link for {bankName}. Please try again later.'
    },
    bankConnectionAllowCTA: {
        id: '_.TrueLayerModal.bankConnectionAllowCTA',
        defaultMessage: 'Allow'
    },
    bankConnectionCancelCTA: {
        id: '_.TrueLayerModal.bankConnectionCancelCTA',
        defaultMessage: 'Cancel'
    }
});
